import { render, staticRenderFns } from "./ButtonBottom2.vue?vue&type=template&id=4a43f238&"
import script from "./ButtonBottom2.vue?vue&type=script&lang=js&"
export * from "./ButtonBottom2.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBottom2.vue?vue&type=style&index=0&id=4a43f238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports